import { getTimer } from "@awayjs/core";
import { TouchPoint, Camera, CameraEvent, Scene } from "@awayjs/scene";
import { RendererEvent, DefaultRenderer } from "@awayjs/renderer";
import { RaycastPicker } from "./pick/RaycastPicker";
import { MouseManager } from "./managers/MouseManager";
import { BasicPartition } from "./partition/BasicPartition";
var View = (function () {
    /*
     ***********************************************************************
     * Disabled / Not yet implemented
     ***********************************************************************
     *
     * private _background:away.textures.Texture2DBase;
     *
     * public _pTouch3DManager:away.managers.Touch3DManager;
     *
     */
    function View(renderer, scene, camera) {
        if (renderer === void 0) { renderer = null; }
        if (scene === void 0) { scene = null; }
        if (camera === void 0) { camera = null; }
        var _this = this;
        this._time = 0;
        this._deltaTime = 0;
        this._backgroundColor = 0x000000;
        this._backgroundAlpha = 1;
        this._viewportDirty = true;
        this._scissorDirty = true;
        this._mousePicker = new RaycastPicker();
        this._partitions = new Object();
        this._pTouchPoints = new Array();
        this._onProjectionChangedDelegate = function (event) { return _this._onProjectionChanged(event); };
        this._onViewportUpdatedDelegate = function (event) { return _this._onViewportUpdated(event); };
        this._onScissorUpdatedDelegate = function (event) { return _this._onScissorUpdated(event); };
        this._mouseManager = MouseManager.getInstance();
        this._mouseManager.registerView(this);
        this.scene = scene || new Scene();
        this.camera = camera || new Camera();
        this.renderer = renderer || new DefaultRenderer();
        //			if (this._shareContext)
        //				this._mouse3DManager.addViewLayer(this);
    }
    View.prototype.getPartition = function (entity) {
        //use registered partition for the displayobject or fallback for scene
        return this._partitions[entity.partition.id] || this._partitions[this._pScene.id];
    };
    View.prototype.setPartition = function (entity, partition) {
        var oldPartition = this._partitions[entity.id];
        if (oldPartition == partition)
            return;
        //clears all existing entities on the partition
        entity.isPartition = false;
        if (oldPartition) {
            oldPartition.dispose();
            delete this._partitions[entity.id];
        }
        if (partition) {
            this._partitions[entity.id] = partition;
            entity.isPartition = true;
        }
    };
    View.prototype.getCollider = function (entity) {
        return this.getPartition(entity).getAbstraction(entity).pickingCollider;
    };
    View.prototype.setCollider = function (entity, collider) {
        this.getPartition(entity).getAbstraction(entity).pickingCollider = collider;
    };
    Object.defineProperty(View.prototype, "mouseX", {
        get: function () {
            return this._pMouseX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "mouseY", {
        get: function () {
            return this._pMouseY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "touchPoints", {
        get: function () {
            return this._pTouchPoints;
        },
        enumerable: true,
        configurable: true
    });
    View.prototype.getLocalMouseX = function (displayObject) {
        return displayObject.transform.inverseConcatenatedMatrix3D.transformVector(this.unproject(this._pMouseX, this._pMouseY, 1000)).x;
    };
    View.prototype.getLocalMouseY = function (displayObject) {
        return displayObject.transform.inverseConcatenatedMatrix3D.transformVector(this.unproject(this._pMouseX, this._pMouseY, 1000)).y;
    };
    View.prototype.getLocalTouchPoints = function (displayObject) {
        var localPosition;
        var localTouchPoints = new Array();
        var len = this._pTouchPoints.length;
        for (var i = 0; i < len; i++) {
            localPosition = displayObject.transform.inverseConcatenatedMatrix3D.transformVector(this.unproject(this._pTouchPoints[i].x, this._pTouchPoints[i].y, 1000));
            localTouchPoints.push(new TouchPoint(localPosition.x, localPosition.y, this._pTouchPoints[i].id));
        }
        return localTouchPoints;
    };
    Object.defineProperty(View.prototype, "renderer", {
        /**
         *
         */
        get: function () {
            return this._pRenderer;
        },
        set: function (value) {
            if (this._pRenderer == value)
                return;
            if (this._pRenderer) {
                //swap the old renderer width and height to the new renderer
                value.width = this._pRenderer.width;
                value.height = this._pRenderer.height;
                this._pRenderer.dispose();
                this._pRenderer.removeEventListener(RendererEvent.VIEWPORT_UPDATED, this._onViewportUpdatedDelegate);
                this._pRenderer.removeEventListener(RendererEvent.SCISSOR_UPDATED, this._onScissorUpdatedDelegate);
                this._mouseManager.unregisterContainer(this._pRenderer.stage.container);
            }
            this._pRenderer = value;
            this._pRenderer.addEventListener(RendererEvent.VIEWPORT_UPDATED, this._onViewportUpdatedDelegate);
            this._pRenderer.addEventListener(RendererEvent.SCISSOR_UPDATED, this._onScissorUpdatedDelegate);
            this._mouseManager.registerContainer(this._pRenderer.stage.container);
            //reset back buffer
            this._pRenderer._iBackgroundR = ((this._backgroundColor >> 16) & 0xff) / 0xff;
            this._pRenderer._iBackgroundG = ((this._backgroundColor >> 8) & 0xff) / 0xff;
            this._pRenderer._iBackgroundB = (this._backgroundColor & 0xff) / 0xff;
            this._pRenderer._iBackgroundAlpha = this._backgroundAlpha;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "backgroundColor", {
        /**
         *
         */
        get: function () {
            return this._backgroundColor;
        },
        set: function (value) {
            if (this._backgroundColor == value)
                return;
            this._backgroundColor = value;
            this._pRenderer._iBackgroundR = ((value >> 16) & 0xff) / 0xff;
            this._pRenderer._iBackgroundG = ((value >> 8) & 0xff) / 0xff;
            this._pRenderer._iBackgroundB = (value & 0xff) / 0xff;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "backgroundAlpha", {
        /**
         *
         * @returns {number}
         */
        get: function () {
            return this._backgroundAlpha;
        },
        /**
         *
         * @param value
         */
        set: function (value) {
            if (value > 1)
                value = 1;
            else if (value < 0)
                value = 0;
            if (this._backgroundAlpha == value)
                return;
            this._pRenderer._iBackgroundAlpha = this._backgroundAlpha = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "camera", {
        /**
         *
         * @returns {Camera3D}
         */
        get: function () {
            return this._pCamera;
        },
        /**
         * Set camera that's used to render the scene for this viewport
         */
        set: function (value) {
            if (this._pCamera == value)
                return;
            if (this._pCamera)
                this._pCamera.removeEventListener(CameraEvent.PROJECTION_CHANGED, this._onProjectionChangedDelegate);
            this._pCamera = value;
            if (this._pScene)
                this._partitions[this._pScene.id].invalidateEntity(this._pCamera);
            this._pCamera.addEventListener(CameraEvent.PROJECTION_CHANGED, this._onProjectionChangedDelegate);
            this._scissorDirty = true;
            this._viewportDirty = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "scene", {
        /**
         *
         * @returns {away.containers.Scene3D}
         */
        get: function () {
            return this._pScene;
        },
        /**
         * Set the scene that's used to render for this viewport
         */
        set: function (value) {
            if (this._pScene == value)
                return;
            if (this._pScene) {
                this._pScene._iUnregisterView(this);
                this._partitions[this._pScene.id].dispose();
            }
            this._pScene = value;
            this._partitions[this._pScene.id] = new BasicPartition(this._pScene);
            this._pScene._iRegisterView(this);
            if (this._pCamera)
                this._partitions[this._pScene.id].invalidateEntity(this._pCamera);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "deltaTime", {
        /**
         *
         * @returns {number}
         */
        get: function () {
            return this._deltaTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "width", {
        /**
         *
         */
        get: function () {
            return this._pRenderer.width;
        },
        set: function (value) {
            this._pRenderer.width = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "height", {
        /**
         *
         */
        get: function () {
            return this._pRenderer.height;
        },
        set: function (value) {
            this._pRenderer.height = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "mousePicker", {
        /**
         *
         */
        get: function () {
            return this._mousePicker;
        },
        set: function (value) {
            if (this._mousePicker == value)
                return;
            if (value == null)
                this._mousePicker = new RaycastPicker();
            else
                this._mousePicker = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "x", {
        /**
         *
         */
        get: function () {
            return this._pRenderer.x;
        },
        set: function (value) {
            this._pRenderer.x = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "y", {
        /**
         *
         */
        get: function () {
            return this._pRenderer.y;
        },
        set: function (value) {
            this._pRenderer.y = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "renderedFacesCount", {
        /**
         *
         * @returns {number}
         */
        get: function () {
            return 0; //TODO
            //return this._pEntityCollector._pNumTriangles;//numTriangles;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Renders the view.
     */
    View.prototype.render = function () {
        this.pUpdateTime();
        //update view and size data
        if (this._scissorDirty) {
            this._scissorDirty = false;
            this._pCamera.projection.setViewRect(this._pRenderer.scissorRect.x, this._pRenderer.scissorRect.y, this._pRenderer.scissorRect.width, this._pRenderer.scissorRect.height);
        }
        if (this._viewportDirty) {
            this._viewportDirty = false;
            this._pCamera.projection.setStageRect(this._pRenderer.viewPort.x, this._pRenderer.viewPort.y, this._pRenderer.viewPort.width, this._pRenderer.viewPort.height);
        }
        // update picking
        if (!this.disableMouseEvents) {
            if (this.forceMouseMove && !this._mouseManager._iUpdateDirty)
                this._mouseManager._iCollision = this.getViewCollision(this._pMouseX, this._pMouseY, this);
            this._mouseManager.fireMouseEvents(this.forceMouseMove);
        }
        //_touch3DManager.updateCollider();
        //render the contents of the scene
        this._pRenderer.render(this);
    };
    /**
     *
     */
    View.prototype.pUpdateTime = function () {
        var time = getTimer();
        if (this._time == 0)
            this._time = time;
        this._deltaTime = time - this._time;
        this._time = time;
    };
    /**
     *
     */
    View.prototype.dispose = function () {
        this._pRenderer.dispose();
        // TODO: imeplement mouseManager / touch3DManager
        this._mouseManager.unregisterView(this);
        //this._touch3DManager.disableTouchListeners(this);
        //this._touch3DManager.dispose();
        this._mouseManager = null;
        //this._touch3DManager = null;
        this._pRenderer = null;
    };
    /**
     *
     */
    View.prototype._onProjectionChanged = function (event) {
        this._scissorDirty = true;
        this._viewportDirty = true;
    };
    /**
     *
     */
    View.prototype._onViewportUpdated = function (event) {
        this._viewportDirty = true;
    };
    /**
     *
     */
    View.prototype._onScissorUpdated = function (event) {
        this._scissorDirty = true;
    };
    View.prototype.project = function (point3d) {
        var v = this._pCamera.project(point3d);
        v.x = (v.x * this._pRenderer.viewPort.width + this._pRenderer.viewPort.width) / 2;
        v.y = (v.y * this._pRenderer.viewPort.height + this._pRenderer.viewPort.height) / 2;
        return v;
    };
    View.prototype.unproject = function (sX, sY, sZ, target) {
        if (target === void 0) { target = null; }
        return this._pCamera.unproject((2 * sX - this._pRenderer.viewPort.width) / this._pRenderer.viewPort.width, (2 * sY - this._pRenderer.viewPort.height) / this._pRenderer.viewPort.height, sZ, target);
    };
    /*TODO: implement Background
     public get background():away.textures.Texture2DBase
     {
     return this._background;
     }
     */
    /*TODO: implement Background
     public set background( value:away.textures.Texture2DBase )
     {
     this._background = value;
     this._renderer.background = _background;
     }
     */
    // TODO: required dependency stageGL
    View.prototype.updateCollider = function () {
        if (!this.disableMouseEvents) {
            // if (!this._pRenderer.shareContext) {
            this._mouseManager._iCollision = this.getViewCollision(this._pMouseX, this._pMouseY, this);
        }
    };
    View.prototype.getViewCollision = function (x, y, view) {
        //update ray
        var rayPosition = view.unproject(x, y, 0);
        var rayDirection = view.unproject(x, y, 1).subtract(rayPosition);
        return this._mousePicker.getCollision(rayPosition, rayDirection, this);
    };
    View.prototype.traversePartitions = function (traverser) {
        for (var key in this._partitions)
            this._partitions[key].traverse(traverser);
    };
    View.prototype.registerObject = function (displayObject) {
        this.getPartition(displayObject).invalidateEntity(displayObject);
    };
    View.prototype.unRegisterObject = function (displayObject) {
        this.getPartition(displayObject).clearEntity(displayObject);
    };
    return View;
}());
export { View };



// WEBPACK FOOTER //
// ../dist/lib/View.js